import {
  Stepper,
  Form,
  Email,
  PhoneNumber,
  NameTextField,
  Button,
  Select,
  TextField,
  Checkbox,
  Hidden,
} from "@lmt/taskforce-react-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { checkboxClasses } from '@mui/material/Checkbox';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/material/styles";

const Text = styled("div")(({ theme }) => ({
  fontFamily: "Roboto,Arial,Helvetica,sans-serif",
}));

const theme = createTheme({
  components: {
      MuiButton: {
        defaultProps: {
            size: "large",
        },
        styleOverrides: {
            root: {
                borderRadius: 5,
                backgroundColor: "#004493",
                color: "#ffffff",
                paddingTop: "10px",
                paddingBottom: "10px",
                minWidth: "120px",
                width: "120",
                textTransform: "capitalize",
                "&:hover": {
                    backgroundColor: "#004493",
                },
            },
        },
    },
    MuiButtonGroup: {
      defaultProps: {
        size: "small",
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
            color: "#2E2E2E",
            [`&.${checkboxClasses.checked}`]: {
              color: "#2E2E2E",
            },
        },
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: "dense",
        size: "small",
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputBase: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputLabel: {
      defaultProps: {
        margin: "dense",
      },
      styleOverrides: {
        root: {
            color: "#2E2E2E",
            '&.Mui-focused': {
              color: '#2E2E2E',
            },
            
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#2E2E2E',
          },
        },
      },
    },
    MuiRadio: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          color: "#2E2E2E", // Default color for the unchecked radio button
          '&.Mui-checked': {
            color: "#2E2E2E", // Color when the radio button is checked
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: "#2E2E2E", // Default color for the label
          '&.Mui-focused': {
            color: "#2E2E2E", // Color for the label when focused
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: "dense",
        size: "medium",
      },
    },
    MuiSelect: {
      styleOverrides: {
        outlined: {
          padding: "12px 12.5px",
        },
      },
    },  
  },
});


function App() {
  return (
    <ThemeProvider theme={theme}>
      <Stepper
        steps={[
          <Form onSubmit={({origin}) => (window.top.location.href = `${origin}/good.php`) } >
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box mt={-0.5}>
                  <NameTextField
                    label="Nom"
                    name="last_name"
                    required="Champ obligatoire"
                    validatorMessage="Nom incorrect"
                    variant="outlined"
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box mt={-0.5}>
                  <NameTextField
                    label="Prénom"
                    name="first_name"
                    required="Champ obligatoire"
                    validatorMessage="Prénom incorrect"
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Box mt={-0.5}>
                  <Email
                  label="E-mail"
                  name="email"
                  required="Champ obligatoire"
                  validatorMessage="Email incorrect"
                  variant="outlined"
                  />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box mt={-0.5}>
                  <PhoneNumber
                  label="Téléphone"
                  name="phone_number_mobile"
                  required="Champ obligatoire"
                  validatorMessage="Téléphone incorrect"
                  variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>
            <Box mt={-0.5}>
              <TextField
                  label="Société"
                  name="company_name"
                  required="Champ obligatoire"
                  variant="outlined"
              />   
            </Box>
            <Box mt={-0.5}>
              <TextField
                  label="Fonction"
                  name="company_function"
                  required="Champ obligatoire"
                  variant="outlined"
              />   
            </Box>
            
            <Box>
              <Checkbox
                required={false}
                label="Je souhaite une démo de la plateforme Pitney Bowes"
                name="reference_optin"
              />
            </Box>

            <Hidden name="address" required={false}/>
            <Hidden name="city" required={false}/>
            <Hidden name="zipcode" required={false}/>
            <Hidden name="company_siret" required={false}/>
            <Hidden name="company_effective_lead" required={false}/>

            <Hidden name="origin"/>

            <Box sx={{ display: 'flex', justifyContent: 'center' }} mt={1}>
              <Button labelValidStep="Valider" />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", color: "#2E2E2E", fontSize: "10px", marginTop: "20px", textAlign: "center",}}>
                <Text>* Champs obligatoires</Text>
            </Box>
          </Form>,
        ]}
      />
    </ThemeProvider>
  );
}

export default App;